import React from 'react';
import PropTypes from 'prop-types';

import classes from './heartIcon.module.css';

const HeartIcon = ({ className }) => (
  <div className={classes.heartIconContainer}>
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="like-btn injected-svg"
        width={56}
        height={56}
      >
        <g id="V4" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <rect
            id="Circle"
            fill="#FFFFFF"
            fillRule="nonzero"
            x="0"
            y="0"
            width="56"
            height="56"
            rx="28"
          ></rect>
          <g
            className="Group"
            transform="translate(27.000000, 5.000000)"
            fillRule="nonzero"
            stroke="#FD5F66"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          >
            <path d="M1,0 L1,5" className="Path-3"></path>
            <path d="M1.5,41 L1.5,46" className="Path-2"></path>
          </g>
          <g
            className="Group"
            transform="translate(28.000000, 28.000000) rotate(60.000000) translate(-28.000000, -28.000000) translate(27.000000, 5.000000)"
            fillRule="nonzero"
            stroke="#FD5F66"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          >
            <path d="M1,-2.27373675e-13 L1,5" className="Path-3"></path>
            <path d="M1.5,41 L1.5,46" className="Path-2"></path>
          </g>
          <path
            d="M28.153959,20.8677974 L28.3060347,20.7157217 C30.5936636,18.4280928 34.3036142,18.4280928 36.5912431,20.7157217 L35.8841363,21.4228284 L36.5912431,20.7157217 C38.878872,23.0033505 38.878872,26.7133011 36.5912431,29.00093 L28.153959,37.4382141 L20.5758574,29.8601125 L19.7169046,29.0011596 C17.4277368,26.7134783 17.4277368,23.0031734 19.7166749,20.7157217 C22.0043038,18.4280928 25.7142544,18.4280928 28.0018832,20.7157217 L28.153959,20.8677974 Z M35.8841363,21.4228284 L35.1770295,22.1299352 C33.6704492,20.6233549 31.2268286,20.6233549 29.7202483,22.1299352 L28.153959,23.6962245 L26.5876697,22.1299352 C25.0810894,20.6233549 22.6374687,20.6233549 21.1306588,22.1301648 C19.623152,23.6366927 19.623152,26.079959 21.1308885,27.5867165 L28.153959,34.609787 L35.1770295,27.5867165 C36.6836098,26.0801362 36.6836098,23.6365155 35.1770295,22.1299352 L35.8841363,21.4228284 Z"
            className="Fill-3"
            fill="#7D878F"
            fillRule="nonzero"
          ></path>
          <path
            d="M28.153959,20.8677974 L28.3060347,20.7157217 C30.5936636,18.4280928 34.3036142,18.4280928 36.5912431,20.7157217 L35.8841363,21.4228284 L36.5912431,20.7157217 C38.878872,23.0033505 38.878872,26.7133011 36.5912431,29.00093 L28.153959,37.4382141 L20.5758574,29.8601125 L19.7169046,29.0011596 C17.4277368,26.7134783 17.4277368,23.0031734 19.7166749,20.7157217 C22.0043038,18.4280928 25.7142544,18.4280928 28.0018832,20.7157217 L28.153959,20.8677974 Z"
            className="Path"
            fill="#FD5F66"
          ></path>
          <g
            className="Group"
            transform="translate(28.000000, 28.000000) rotate(120.000000) translate(-28.000000, -28.000000) translate(27.000000, 5.000000)"
            fillRule="nonzero"
            stroke="#FD5F66"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          >
            <path d="M1,4.54747351e-13 L1,5" className="Path-3"></path>
            <path d="M1.5,41 L1.5,46" className="Path-2"></path>
          </g>
        </g>
      </svg>
    </div>
  </div>
);

HeartIcon.propTypes = {
  className: PropTypes.string,
};

HeartIcon.defaultProps = {
  className: 'jobCardtIcon',
};

export default HeartIcon;
